var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { captureException } from '@sentry/react';
import defaultTranslations from '@app/translations/boilerplate.en.json';
import { createTranslationProxyClient } from '../clients';
const doLoad = (namespace, language) => __awaiter(void 0, void 0, void 0, function* () {
    const translationProxyClient = createTranslationProxyClient();
    const { data } = yield translationProxyClient.getJsTranslations(namespace, language);
    return Object.assign(Object.assign({}, defaultTranslations), data);
});
export default (language, namespace, callback) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        callback(null, yield doLoad(namespace, language));
    }
    catch (error) {
        captureException(error);
        callback(null, defaultTranslations);
    }
});
